module.exports = __webpack_public_path__ + "img/this-month-earn.2b1f7891.svg";